import React from 'react';
import { Logo } from './Logo';
import { Link } from 'react-router-dom';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0a2351] text-white py-12" data-id="element-104">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="flex flex-col md:flex-row justify-between mb-8" data-id="element-106">
          <div className="mb-8 md:mb-0" data-id="element-107">
            <div className="mb-4" data-id="element-108">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mCbJnqzyCghsjjmS5hz9a5/Generated_Image_October_07%2C_2025_-_3_11AM.png" alt="Sapis Capital Group Logo" className="h-12 md:h-14" data-id="element-109" />
            </div>
            <p className="max-w-xs text-gray-300" data-id="element-110">
              Strategic capital for visionary growth. Empowering exceptional
              companies with the resources to achieve sustainable long-term
              success.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8" data-id="element-111">
            <div data-id="element-112">
              <h4 className="text-lg font-semibold mb-4" data-id="element-113">Quick Links</h4>
              <ul className="space-y-2" data-id="element-114">
                <li data-id="element-115">
                  <Link to="/about-us" className="text-gray-300 hover:text-white transition-colors" data-id="element-116">
                    About
                  </Link>
                </li>
                <li data-id="element-117">
                  <Link to="/investments" className="text-gray-300 hover:text-white transition-colors" data-id="element-118">
                    Investments
                  </Link>
                </li>
                <li data-id="element-119">
                  <Link to="/portfolio" className="text-gray-300 hover:text-white transition-colors" data-id="element-120">
                    Portfolio
                  </Link>
                </li>
                <li data-id="element-121">
                  <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-122">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-123">
              <h4 className="text-lg font-semibold mb-4" data-id="element-124">Legal</h4>
              <ul className="space-y-2" data-id="element-125">
                <li data-id="element-126">
                  <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors" data-id="element-127">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-128">
                  <Link to="/terms-of-use" className="text-gray-300 hover:text-white transition-colors" data-id="element-129">
                    Terms of Use
                  </Link>
                </li>
                <li data-id="element-130">
                  <Link to="/disclosures" className="text-gray-300 hover:text-white transition-colors" data-id="element-131">
                    Disclosures
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1" data-id="element-132">
              <h4 className="text-lg font-semibold mb-4" data-id="element-133">Connect</h4>
              <ul className="space-y-2" data-id="element-134">
                <li data-id="element-135">
                  <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-136">
                    LinkedIn
                  </a>
                </li>
                <li data-id="element-137">
                  <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-138">
                    Twitter
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 flex flex-col sm:flex-row justify-between items-center" data-id="element-139">
          <p className="text-gray-400 text-sm mb-4 sm:mb-0" data-id="element-140">
            &copy; {currentYear} Sapis Capital Group. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm" data-id="element-141">
            Designed with excellence for strategic capital management.
          </p>
        </div>
      </div>
    </footer>;
};